"use client";

import { c as _c } from "react/compiler-runtime";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import type { DropInteractionParams } from "@/components/waves/drops/Drop";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import NotificationDrop from "./NotificationDrop";
import NotificationHeader from "./NotificationHeader";
import NotificationTimestamp from "./NotificationTimestamp";
import { getIsDirectMessage, useWaveNavigation } from "../utils/navigationUtils";
interface NotificationWithDropProps {
  readonly drop: ApiDrop;
  readonly actionText: string;
  readonly createdAt: number;
  readonly activeDrop: ActiveDropState | null;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onQuote: (param: DropInteractionParams) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
}
export default function NotificationWithDrop(t0) {
  const $ = _c(41);
  const {
    drop,
    actionText,
    createdAt,
    activeDrop,
    onReply,
    onQuote,
    onDropContentClick
  } = t0;
  const {
    createReplyClickHandler,
    createQuoteClickHandler
  } = useWaveNavigation();
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== actionText || $[1] !== activeDrop || $[2] !== createQuoteClickHandler || $[3] !== createReplyClickHandler || $[4] !== createdAt || $[5] !== drop || $[6] !== onQuote || $[7] !== onReply) {
    const isDirectMessage = getIsDirectMessage(drop.wave);
    t7 = "tw-w-full tw-flex tw-flex-col tw-space-y-2";
    let t9;
    if ($[17] !== drop.author) {
      t9 = <NotificationsFollowBtn profile={drop.author} size={UserFollowBtnSize.SMALL} />;
      $[17] = drop.author;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] !== actionText) {
      t10 = <span className="tw-text-iron-400 tw-font-normal tw-text-sm">{actionText}</span>;
      $[19] = actionText;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    let t11;
    if ($[21] !== createdAt) {
      t11 = <NotificationTimestamp createdAt={createdAt} />;
      $[21] = createdAt;
      $[22] = t11;
    } else {
      t11 = $[22];
    }
    if ($[23] !== drop.author || $[24] !== t10 || $[25] !== t11 || $[26] !== t9) {
      t8 = <NotificationHeader author={drop.author} actions={t9}>{t10}{t11}</NotificationHeader>;
      $[23] = drop.author;
      $[24] = t10;
      $[25] = t11;
      $[26] = t9;
      $[27] = t8;
    } else {
      t8 = $[27];
    }
    T0 = NotificationDrop;
    t1 = drop;
    t2 = activeDrop;
    t3 = onReply;
    t4 = onQuote;
    t5 = createReplyClickHandler(drop.wave.id, isDirectMessage);
    t6 = createQuoteClickHandler(isDirectMessage);
    $[0] = actionText;
    $[1] = activeDrop;
    $[2] = createQuoteClickHandler;
    $[3] = createReplyClickHandler;
    $[4] = createdAt;
    $[5] = drop;
    $[6] = onQuote;
    $[7] = onReply;
    $[8] = T0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    T0 = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
  }
  let t9;
  if ($[28] !== T0 || $[29] !== onDropContentClick || $[30] !== t1 || $[31] !== t2 || $[32] !== t3 || $[33] !== t4 || $[34] !== t5 || $[35] !== t6) {
    t9 = <T0 drop={t1} activeDrop={t2} onReply={t3} onQuote={t4} onReplyClick={t5} onQuoteClick={t6} onDropContentClick={onDropContentClick} />;
    $[28] = T0;
    $[29] = onDropContentClick;
    $[30] = t1;
    $[31] = t2;
    $[32] = t3;
    $[33] = t4;
    $[34] = t5;
    $[35] = t6;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  let t10;
  if ($[37] !== t7 || $[38] !== t8 || $[39] !== t9) {
    t10 = <div className={t7}>{t8}{t9}</div>;
    $[37] = t7;
    $[38] = t8;
    $[39] = t9;
    $[40] = t10;
  } else {
    t10 = $[40];
  }
  return t10;
}